import React, { useEffect } from 'react';

import { BarcodeLabel } from '@components/BarcodeLabel';
import { useBarcode, useQrcode } from '@hooks/queries/useBarcode';
import { useSearch } from '@hooks/useSearch';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const searchData = t.type({
  createdAt: h.string(),
  d2dNo: h.string(),
});

export const PrintBarcode: React.FC = () => {
  const { search } = useSearch(searchData);
  const { data } = useBarcode(search.d2dNo);
  const qrData = useQrcode(search.d2dNo);

  useEffect(() => {
    document.title = `Barcode ${search.d2dNo}`;
  }, []);

  return (
    <BarcodeLabel
      createdAt={search.createdAt?.substring(0, 19) || ''}
      barcodeImgSrc={data || ''}
      qrcodeImgSrc={qrData.data || ''}
      d2dNo={search.d2dNo}
    />
  );
};
